import {
  red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal, green,
  lightGreen, lime, yellow, amber, orange, deepOrange, brown, grey, blueGrey
} from "@material-ui/core/colors";

const colorPalette = [
  red[600],
  pink[600],
  purple[600],
  deepPurple[600],
  indigo[600],
  blue[700],
  lightBlue[800],
  cyan[800],
  teal[700],
  green[700],
  lightGreen[800],
  lime[900],
  yellow[900],
  amber[800],
  orange[800],
  deepOrange[700],
  brown[600],
  grey[700],
  blueGrey[600],
  indigo[900]
];

export const getUserColor = (name) => {
  if (!name) return "#000000";
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const index = Math.abs(hash) % colorPalette.length;
  
  return colorPalette[index];
};